module.exports = __webpack_public_path__ + "img/3.31811bf7.png";